import styled from "styled-components";

export const Styled = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
